import { useCallback, useEffect, useRef, useState } from "react";
import {  deleteSkuMapplingById, getAllSkuMapping } from "../../services/AllServices";
import { showMessage } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../components/PrimaryButton";
import ConfirmationModal from "../../components/ConfirmationModal";

const useMappingManagementViewController = () => {

    const [showModal, setShowModal] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [mappingList, setMappingList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMoreItems, setHasMoreItems] = useState(true);
    const navigate = useNavigate();
    const pageSize = 15;
    const totalPages = 10;
    const renderAfterCalled = useRef(false);
    const [loading, setLoading] = useState(false);
  
    const handlePageChange = (page) => {
      if (page > totalPages || page < 1 || !hasMoreItems) {
        return;
      }
  
      setCurrentPage(page);
    };
    const fetchData = useCallback(async () => {
      setLoading(true);
      try {
        const response = await getAllSkuMapping(currentPage, pageSize);
        if (response?.data?.sku_to_gwp_mappings.length > 0) {
          setHasMoreItems(true);
        } else {
          setHasMoreItems(false);
        }
  
        setMappingList(response?.data?.sku_to_gwp_mappings);
      } catch (error) {
        showMessage("error", error?.data.message || "Something went wrong");
      }
      setLoading(false);
    }, [currentPage]);
  
    useEffect(() => {
      if (!renderAfterCalled.current) {
        fetchData();
      }
      renderAfterCalled.current = true;
    }, [fetchData]);
    const handleShow = (index) => {
      setClickedIndex(index);
      setShowModal(true);
    };
    const handleClose = () => {
      setShowModal(false);
    };
    const handleConfirm = async (id) => {
      try {
        await deleteSkuMapplingById(id);
        showMessage("success", "Mapping Deleted Successfully");
        handleClose();
        fetchData();
      } catch (error) {
       showMessage("error", error?.response?.data?.message || "Something went wrong");
      }
    };
    const goBack = () => {
      navigate('/home')
    };
  
    const columns = [
      {
        Header: "S.No.",
        Cell: ({ row }) => row.index + 1,
        fixed: "left",
        key: "srno",
      },
      {
        Header: "Good Stock SKU",
        columns: [
          {
            Header: "WATSON SKU",
            accessor: "good_item_watson_id",
            key: "good_item_watson_id",
          },
          {
            Header: "HS SKU",
            accessor: "good_item_hs_id",
            key: "good_item_hs_id",
          },
        ],
      },
      {
        Header: "GWP SKU",
        columns: [
          {
            Header: "WATSON SKU",
            accessor: "gwp_item_watson_id",
            key: "gwp_item_watson_id",
          },
          {
            Header: "HS SKU",
            accessor: "gwp_item_hs_id",
          },
        ],
      },
      {
        Header: "Description",
        accessor: "gwp_item_name",
        fixed: "right",
        key: "gwp_item_name",
      },
  
      {
        Header: "Action",
        accessor: "id",
        fixed: "right",
        key: "action",
        Cell: ({ row, index }) => (
          <div key={index}>
            <>
              <PrimaryButton
                text="Delink "
                className="width-auto h-0 view-btn mx-2"
                onClick={() => handleShow(index)}
              />
              <ConfirmationModal
                confirmationMessage={`Are you sure you want to remove this mapping ?`}
                confirmattionKey={index}
                show={showModal && clickedIndex === index}
                id={index}
                onHide={handleClose}
                onConfirm={() => handleConfirm(row?.values?.id)}
              />
            </>
            <PrimaryButton
              text="Edit"
              className="width-auto h-0 create-btn"
              onClick={() => {
                navigate(
                  `/edit-mapping/${row?.values?.id ? row?.values?.id : index}`
                );
              }}
            />
          </div>
        ),
      },
    ];


    return {
        goBack,
        mappingList,
        currentPage,
        pageSize,
        totalPages,
        handlePageChange,
        navigate,
        columns,  
        loading,
    };
};

export default useMappingManagementViewController;